import { animate, AnimationTriggerMetadata, style, transition, trigger } from '@angular/animations';

export const opacityAnimation: AnimationTriggerMetadata = trigger('opacity', [
  transition('void => *', [style({ opacity: 0 }), animate('150ms', style({ opacity: 1 }))]),
  transition('* => void', [animate('150ms', style({ opacity: 0 }))]),
]);
